/**
 * Configura o `@tasca/client-sdk` para esta plataforma.
 *
 * Importado pelo ponto de entrada ANTES de qualquer outra coisa do SDK: a
 * primeira chamada ao REST ou ao gateway já encontra a configuração feita, e
 * falhar aqui é melhor que descobrir um `undefined/api/v1` três camadas
 * acima.
 *
 * A web e o desktop partilham este ficheiro porque partilham a build. A
 * diferença entre eles cabe numa linha: o browser guarda o refresh token num
 * cookie HttpOnly (e `secrets` é `null`), a app instalada guarda-o no cofre
 * do sistema.
 */
import { configure } from '@tasca/client-sdk';
import { native } from './desktop.js';
import { ORIGIN } from './origin.js';
import { loadSettings } from './voiceStorage.js';
import { useStore } from '@tasca/client-sdk';

configure({
  origin: ORIGIN,
  secrets: native?.secrets ?? null,
});

// As preferências de voz são lidas de forma síncrona no browser; o store
// nasce com os valores por omissão e recebe-as aqui. (No telemóvel a leitura
// é assíncrona, e é por isso que o SDK não a faz por si — ver
// packages/client-sdk/src/voice/settings.ts.)
useStore.getState().setVoiceSettings(loadSettings());
